import Vue from "vue";
import Component from "vue-class-component";

import { AppointmentInterface } from "@/api/Interfaces/AppointmentInterface";
import { ClinicPhoneInterface } from "@/api/Interfaces/ClinicPhoneInterface";
import { isArray } from "lodash";
import { AddressInterface } from "@/api/Interfaces/AddressInterface";
import { PhoneInterface } from "@/api/Interfaces/PhoneInterface";
import GoogleAnalyticsEvents from "@/helpers/GoogleAnalyticsEvents";

const ComponentProps = Vue.extend({
  props: {
    appointment: {
      type: Object as () => AppointmentInterface,
      required: true,
    },
  },
});

@Component({
  name: "ServiceConfirmationComponent",
})
export default class ServiceConfirmationComponent extends ComponentProps {
  cx_name!: string;
  cx_procedure!: string;
  cx_location!: string;
  cx_address!: AddressInterface;
  cx_phone!: string | string[] | PhoneInterface | PhoneInterface[];
  cx_date!: string;
  cx_time!: string;
  cx_importantInformations!: string | undefined;

  constructor() {
    super();

    this.cx_name =
      this.appointment.patient?.first_name || this.appointment.patient?.name || "Paciente";
    this.cx_procedure = this.appointment.service?.name || "";
    this.cx_location = this.appointment.clinic?.name || "";
    this.cx_address = this.appointment.clinic?.address || ({} as AddressInterface);
    this.cx_phone = this.preparePhoneNumber(this.appointment.clinic?.phones || []);
    this.cx_date = this.appointment.start_at || "";
    this.cx_importantInformations = this.appointment.clinic?.online_appointment_message || "";
    this.cx_time = "";
  }

  mounted() {
    GoogleAnalyticsEvents.loadAppointmentConfirmation();
    this.$emit("setLoading", false);
  }

  preparePhoneNumber(phone: ClinicPhoneInterface | ClinicPhoneInterface[]): string | string[] {
    try {
      if (isArray(phone)) return phone.map((item: ClinicPhoneInterface) => item.phone).join(", ");

      return phone.phone;
    } catch (e) {
      return "-";
    }
  }

  closeAppoint(): void {
    this.$emit("close", false);
  }
}
